/**
 * API 機能の利用開始日に到達しているか判定する
 * - api_enabled が false の場合は常に false
 * - api_start_date が未設定の場合は true（旧データ互換）
 * - api_start_date <= now の場合のみ true
 */
export const isApiAccessActive = (
  apiEnabled: boolean,
  apiStartDate: Date | null | undefined,
  now: Date = new Date(),
): boolean => {
  if (!apiEnabled) return false;
  if (!apiStartDate) return true;
  return apiStartDate.getTime() <= now.getTime();
};

/**
 * Firestore から取得した raw データの `api_start_date` を Date | null に変換する
 * Timestamp / Date / undefined / null いずれも受け付ける
 */
export const toApiStartDate = (value: unknown): Date | null => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (
    typeof value === 'object' &&
    value !== null &&
    'toDate' in value &&
    typeof (value as { toDate: () => Date }).toDate === 'function'
  ) {
    return (value as { toDate: () => Date }).toDate();
  }
  return null;
};
